import { isPlainObject } from 'lodash';

export default {
    data() {
        return {
            fileFields: [],
        };
    },
    methods: {
        /**
         * Create fake files for the VFile input.
         * We keep files data in data.originalFiles.
         *
         * @param {Object} entity - Data from API
         * @return {Object}
         */
        // TODO should be remove after all forms been changed to use dynamic langs
        async prepareEditionData(entity) {
            const originalFiles = {};
            const preparedFiles = {};
            let fileInfo;

            const promises = [];
            this.fileFields.forEach((fieldName, index) => {
                fileInfo = entity[fieldName];

                if (fileInfo) {
                    // for use case when this.sampleAttribute exist
                    if (this.sampleAttribute && this.sampleAttribute === fieldName) {
                        promises[index] = this.$rq.downloadFile(fileInfo.id);
                    }

                    // when this.sampleAttribute does not exist
                    if (!this.sampleAttribute) {
                        promises[index] = this.$rq.downloadFile(fileInfo.id);
                    }
                }
            });

            const responses = await Promise.all(promises);

            this.fileFields.forEach((fieldName, index) => {
                fileInfo = entity[fieldName];
                if (fileInfo) {
                    originalFiles[fieldName] = fileInfo;
                    const blob = responses[index]?.data;
                    if (blob) {
                        const fileName = fileInfo.fileName || fileInfo.link?.fileName;
                        const fileFormat = fileInfo.format || fileInfo.metadata?.format;
                        preparedFiles[fieldName] = new File([blob], fileName, {
                            type: fileFormat,
                        });
                    }
                }
            });

            return {
                ...entity,
                ...preparedFiles,
                originalFiles,
            };
        },

        async prepareEditData(entity) {
            const originalFiles = {};
            const preparedFiles = {};
            let fileInfo;

            const promises = [];
            entity.files.forEach(({ file }) => promises.push(this.$rq.downloadFile(file.id)));
            const responses = await Promise.all(promises);

            entity.files.forEach((file, index) => {
                fileInfo = file.file;
                if (fileInfo) {
                    originalFiles[file.lang] = fileInfo;
                    const blob = responses[index].data;
                    if (blob) {
                        preparedFiles[file.lang] = new File([blob], fileInfo.fileName, {
                            type: fileInfo.format,
                        });
                    }
                }
            });

            return {
                ...entity,
                files: preparedFiles,
                originalFiles,
            };
        },
        /**
         * @param {String} fieldName the name of the field of the object that contain a file?
         * @param lang the language of the file, default to 'en' when not provided
         * @dev TODO: define the use case of the fieldName
         */
        async onClickViewFile(fieldName, lang = 'en') {
            const { originalFiles } = this.data;
            if (fieldName && fieldName !== '') {
                if (isPlainObject(originalFiles[fieldName])) {
                    const file = originalFiles[fieldName];
                    const { data } = await this.$rq.downloadFile(file.id);
                    this.$utils.saveFileOnDisk(data, file.fileName);
                }
            } else { // there is no field name, so we assume that the file is in the root of the object
                const file = originalFiles;
                const { data } = await this.$rq.downloadFile(file[lang].id);
                this.$utils.saveFileOnDisk(data, file[lang].fileName);
            }
        },
        updateData() {
            // When creation, no need for additional process
            if (!this.isEdition) {
                this.$emit('sendData', this.data);
                return;
            }

            // Specific treatment for the files
            const { originalFiles, ...payload } = this.data;
            let fieldValue;

            this.fileFields.forEach(fieldName => {
                fieldValue = payload[fieldName];

                if (fieldValue instanceof File) {
                    //  Fake file, user didn't change it, put back the original
                    if (fieldValue.size === 0) {
                        payload[fieldName] = originalFiles[fieldName];
                    }
                } else if (originalFiles[fieldName]) {
                    // Remove the file if it was there in the first place
                    payload[fieldName] = '';
                }
            });

            this.$emit('sendData', payload);
        },
    },
};
